import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    position: "relative",
    width: "100%",
  },
  closedContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  },
  compactContainer: {
    display: "flex",
    alignItems: "center",
  },
  compactDisabled: {
    cursor: "default",
  },
  compactChipsRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 8,
    cursor: "pointer",
    borderRadius: 4,
    padding: '4px 8px',

    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  moreCount: {
    color: theme.palette.text.disabled,
    fontWeight: 400,
    whiteSpace: "nowrap",
    marginLeft: 2,
  },
  chipsRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 8,
    flex: 1,
    minWidth: 0,
  },
  iconBtn: {
    padding: 0,
  },
  addOnHover: {
    opacity: 0,
    "tr:hover &": {
      opacity: 1,
    },
  },
  chipInInput: {
    margin: "2px 4px 2px 0 !important",
    maxWidth: "200px !important",
  },
  autocomplete: {
    "& .MuiOutlinedInput-root": {
      flexWrap: "wrap",
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
      paddingRight: "60px !important",
      minHeight: 40,
    },
  },
  listbox: {
    overflowY: "scroll !important" as any,
    "&::-webkit-scrollbar": {
      width: 6,
      display: "block",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: alpha(theme.palette.action.active, 0.3),
      borderRadius: 3,
      "&:hover": {
        backgroundColor: alpha(theme.palette.action.active, 0.5),
      },
    },
  },
  endAdornment: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    right: 8,
    top: "50%",
    transform: "translateY(-50%)",
  },
  clearButton: {
    padding: 2,
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
  icon: {
    color: theme.palette.action.active,
  },
  newTagHint: {
    marginLeft: 8,
    color: theme.palette.text.disabled,
    whiteSpace: "nowrap",
  },
}));
